/* design pass 30 Sep 2026: one header on every template, so each element may be absent (the cart page has no drawer) */
window.addEventListener('scroll', function () {
  var navbar = document.getElementById('section-navbar');
  if (!navbar) return;
  if (window.scrollY > 40) { navbar.classList.add('scrolled'); } else { navbar.classList.remove('scrolled'); }
});

var cartOpen = document.getElementById('nav-cart-open');
var cartOpener = null;
var cartDrawer = document.getElementById('site-cart-sidebar');
if (cartDrawer) {
  (function (drawer) {
    var opened = false;
    var lastFocus = document.activeElement;
    var opener = null;
    var madeInert = [];
    var drawerFocus = null;
    var lastPointerDown = 0;
    var pointerSequence = 0;
    var frameExitTimer = null;
    var frameEntryTimer = null;
    var focusSelector = 'a[href], button, input, select, textarea, [tabindex], summary, [contenteditable], iframe';
    function effectiveTabIndex(el) {
      var attr = el.getAttribute('tabindex');
      if (attr !== null && /^\s*[+-]?\d+\s*$/.test(attr)) return parseInt(attr, 10);
      var editable = el.getAttribute('contenteditable');
      // editing hosts are native stops even when their tabIndex property is -1
      if (attr === null && editable !== null && /^(|true|plaintext-only)$/i.test(editable) && (!el.parentElement || !el.parentElement.isContentEditable)) return 0;
      return el.tabIndex;
    }
    function focusable(el, frameScope) {
      if (!el || !el.matches(focusSelector) || el.matches(':disabled') || effectiveTabIndex(el) < 0 || !el.getClientRects().length) return false;
      if (frameScope && el.ownerDocument.defaultView.getComputedStyle(el).visibility !== 'visible') return false;
      for (var parent = el; parent; parent = parent.parentNode || parent.host) {
        if (parent.nodeType === 1 && parent.hasAttribute('inert')) return false;
      }
      return true;
    }
    function tabStops(root, frameScope) {
      var candidates = [];
      function visit(parent) {
        var children = parent.children;
        for (var i = 0; i < children.length; i++) {
          var el = children[i];
          if (el.shadowRoot) {
            // a shadow tree takes its host's place in the parent's Tab order
            if (!el.hasAttribute('tabindex') || effectiveTabIndex(el) >= 0) {
              candidates.push({ el: el, index: candidates.length, tabIndex: Math.max(0, effectiveTabIndex(el)), scope: tabStops(el.shadowRoot, frameScope) });
            }
          } else {
            if (focusable(el, frameScope)) candidates.push({ el: el, index: candidates.length, tabIndex: effectiveTabIndex(el) });
            visit(el);
          }
        }
      }
      visit(root);
      candidates.sort(function (a, b) {
        if (a.tabIndex === b.tabIndex) return a.index - b.index;
        if (!a.tabIndex) return 1;
        if (!b.tabIndex) return -1;
        return a.tabIndex - b.tabIndex;
      });
      var items = [];
      for (var i = 0; i < candidates.length; i++) {
        var candidate = candidates[i];
        if (focusable(candidate.el, frameScope)) items.push(candidate.el);
        if (candidate.scope) items = items.concat(candidate.scope);
      }
      return items;
    }
    function activeStop() {
      var active = document.activeElement;
      while (active && active.shadowRoot && active.shadowRoot.activeElement) active = active.shadowRoot.activeElement;
      return active;
    }
    function focusStop(el, backwards) {
      drawerFocus = el;
      if (el.tagName === 'IFRAME') {
        var frameDoc = null;
        try { frameDoc = el.contentDocument; } catch (error) { /* cross-origin frames keep their own focus */ }
        if (frameDoc) {
          var items = tabStops(frameDoc, true);
          if (items.length) { items[backwards ? items.length - 1 : 0].focus(); return; }
        }
      }
      el.focus();
    }
    function rememberPointer() { lastPointerDown = Date.now(); pointerSequence++; }
    function rememberFrameEntry() {
      if (frameEntryTimer !== null) return;
      // frame controls do not send focusin to the parent document
      frameEntryTimer = setTimeout(function () {
        frameEntryTimer = null;
        if (!opened || !drawer.classList.contains('sidebar--opened')) return;
        var active = activeStop();
        if (active && active.tagName === 'IFRAME' && tabStops(drawer).indexOf(active) !== -1) drawerFocus = active;
      }, 0);
    }
    function containFrameExit(e) {
      if (!opened || !drawer.classList.contains('sidebar--opened')) return;
      var previous = drawerFocus;
      drawerFocus = activeStop() || e.target;
      if (drawer.contains(e.target) || !previous || previous.tagName !== 'IFRAME' || Date.now() - lastPointerDown < 500) return;
      var items = tabStops(drawer);
      var index = items.indexOf(previous);
      if (index === -1) return;
      var positionStop = previous;
      var root = positionStop.getRootNode();
      // compare in the main document; shadow descendants appear disconnected
      while (root.host) { positionStop = root.host; root = positionStop.getRootNode(); }
      var position = positionStop.compareDocumentPosition(e.target);
      if (position & 1) return;
      var backwards = !!(position & 2);
      if (!(position & 6)) return;
      if (frameExitTimer !== null) return;
      var target = items[(index + (backwards ? -1 : 1) + items.length) % items.length];
      var pointerAtExit = pointerSequence;
      // let the native focus change finish before rejoining the drawer's order
      frameExitTimer = setTimeout(function () {
        frameExitTimer = null;
        if (!opened || !drawer.classList.contains('sidebar--opened') || drawer.contains(document.activeElement) || pointerSequence !== pointerAtExit) return;
        focusStop(target, backwards);
      }, 0);
    }
    function containTab(e) {
      if (e.key !== 'Tab') return;
      var items = tabStops(drawer);
      var active = activeStop();
      e.preventDefault();
      if (!items.length) { drawer.focus(); return; }
      // move every Tab ourselves so consent controls cannot split the drawer's order
      var index = items.indexOf(active);
      if (index === -1) index = e.shiftKey ? items.length - 1 : 0;
      else index = (index + (e.shiftKey ? -1 : 1) + items.length) % items.length;
      focusStop(items[index], e.shiftKey);
    }
    function syncDrawer() {
      var nowOpen = drawer.classList.contains('sidebar--opened');
      if (nowOpen === opened) return;
      opened = nowOpen;
      if (opened) {
        opener = cartOpener || lastFocus;
        cartOpener = null;
        // leave the backdrop and consent controls usable, and preserve existing inert
        var children = document.body.children;
        for (var i = 0; i < children.length; i++) {
          var el = children[i];
          if (el === drawer || el.classList.contains('site-overlay') || el.id === 'shopify-pc__banner' || /^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(el.tagName) || el.hasAttribute('inert')) continue;
          el.setAttribute('inert', '');
          madeInert.push(el);
        }
        document.addEventListener('keydown', containTab);
        document.addEventListener('focusin', containFrameExit);
        document.addEventListener('pointerdown', rememberPointer, true);
        window.addEventListener('blur', rememberFrameEntry);
        drawerFocus = activeStop();
        if (!drawer.contains(document.activeElement)) {
          var close = drawer.querySelector('[data-js-close]');
          (close || drawer).focus();
        }
      } else {
        for (var j = 0; j < madeInert.length; j++) madeInert[j].removeAttribute('inert');
        madeInert = [];
        document.removeEventListener('keydown', containTab);
        document.removeEventListener('focusin', containFrameExit);
        document.removeEventListener('pointerdown', rememberPointer, true);
        window.removeEventListener('blur', rememberFrameEntry);
        if (frameExitTimer !== null) clearTimeout(frameExitTimer);
        frameExitTimer = null;
        if (frameEntryTimer !== null) clearTimeout(frameEntryTimer);
        frameEntryTimer = null;
        drawerFocus = null;
        var target = document.documentElement.contains(opener) && focusable(opener) ? opener : document.getElementById('nav-cart-open');
        if (target) target.focus();
        opener = null;
      }
    }
    // remember focus before theme code opens the drawer, including programmatic opens
    document.addEventListener('focusin', function (e) {
      if (!drawer.classList.contains('sidebar--opened')) lastFocus = e.target;
    });
    new MutationObserver(syncDrawer).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    syncDrawer();
  })(cartDrawer);
}
if (cartOpen) {
  cartOpen.addEventListener('click', function () {
    var drawer = document.getElementById('site-cart-sidebar');
    if (!drawer) { window.location.href = '/cart'; return; }
    // Safari does not focus buttons on mouse click
    if (!drawer.classList.contains('sidebar--opened')) cartOpener = cartOpen;
    // the theme's own drawer opening (overlay, inert page) when its script has loaded
    if (typeof drawer.show === 'function') { drawer.show(); } else { drawer.classList.add('sidebar--opened'); drawer.style.display = 'grid'; }
  });
}

// the theme header wired the overlay click; with the navbar on every template it is wired here
var overlay = document.querySelector('.site-overlay');
if (overlay) {
  overlay.addEventListener('click', function () {
    var opened = document.querySelector('sidebar-drawer.sidebar--opened');
    if (opened && typeof opened.hide === 'function') { opened.hide(); }
  });
}

var btnOpen = document.querySelector('.nav-open-btn');
var btnClose = document.querySelector('.nav-close-btn');
var navMenu = document.getElementById('nav-menu-mobile');
if (btnOpen && navMenu) {
  btnOpen.addEventListener('click', function () { navMenu.classList.add('nav-opened'); btnOpen.setAttribute('aria-expanded', 'true'); });
}
if (btnClose && navMenu) {
  btnClose.addEventListener('click', function () { navMenu.classList.remove('nav-opened'); if (btnOpen) { btnOpen.setAttribute('aria-expanded', 'false'); btnOpen.focus(); } });
}
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape' && navMenu && navMenu.classList.contains('nav-opened')) { navMenu.classList.remove('nav-opened'); if (btnOpen) { btnOpen.setAttribute('aria-expanded', 'false'); btnOpen.focus(); } }
});
